import angular from 'angular'
import collectionExport from './collectionExport'

export default angular
    .module('outputManage.taxFilling', [collectionExport])
    .config([
        '$stateProvider',
        ($stateProvider) => {
            $stateProvider.state('outputManage.taxFilling', {
                url: '/ovat',
                template: '<div ui-view></div>',
                abstract: true,
                title: '报税处理',
            })
        },
    ]).name



// WEBPACK FOOTER //
// ./src/app/outputManage/taxFilling/index.js